import Skeleton from '@mui/material/Skeleton';
import { SkeletonRow } from './SkeletonTypes';

interface TextRowsSkeletonProps {
  rows: SkeletonRow[];
  rowsGap?: number | string;
}

export default function TextRowsSkeleton({ rows, rowsGap }: TextRowsSkeletonProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: rowsGap }}>
      {rows.map((row, index) => (
        <Skeleton
          key={index}
          variant="text"
          width={row.width}
          height={row.height || '10px'}
          animation="pulse"
          sx={{ bgcolor: 'var(--surface-grey-lighter)' }}
        />
      ))}
    </div>
  );
}
